import { useAgent, useCopilotKit } from '@copilotkit/react-core/v2'
import { useEffect } from 'react'
import { ExpeditedDeliveryRequestForm } from '../components/AI/ExpeditedDeliveryRequestForm'

const SUBMISSION_MESSAGE =
  "Your form has been submitted and our team will review to see if your in-hands date is workable and if so, what, if any, additional expedited shipping costs would be necessary. Please note, filling out this form does not mean your delivery date will be met, it only means we will make every effort to make it happen for you and will be in touch with an update asap. Is there anything else I can help you with today?"

function ShowRushDeliveryFormRenderer({
  args,
}: {
  status: string
  args: { name?: string; email?: string; orderNumber?: string }
}) {
  const { agent } = useAgent()
  const { copilotkit } = useCopilotKit()

  const handleRespond = () => {
    agent.setMessages([
      ...(agent.messages ?? []),
      { id: crypto.randomUUID(), role: 'assistant' as const, content: SUBMISSION_MESSAGE },
    ])
    // Run the agent so the backend processes the submission result and clears
    // the pending showRushDeliveryForm tool call — without this, subsequent
    // product requests route through a different backend path (text list).
    copilotkit.runAgent({ agent }).catch(() => {})
  }

  return (
    <ExpeditedDeliveryRequestForm
      name={args?.name}
      email={args?.email}
      orderNumber={args?.orderNumber}
      respond={handleRespond}
    />
  )
}

export function useShowRushDeliveryFormAction() {
  const { copilotkit } = useCopilotKit()
  useEffect(() => {
    const core = copilotkit as { addHookRenderToolCall: (r: object) => void }
    core.addHookRenderToolCall({
      name: 'showRushDeliveryForm',
      args: null,
      render: ShowRushDeliveryFormRenderer,
    })
  }, [copilotkit])
}
